import { createContext } from "react";
import { GeneralStore } from "./general_store";
import { MapStore } from "@adactiveasia/adsign-map";

export const rootStoreContext = createContext({
  generalStore: new GeneralStore(),
  mapStore: new MapStore(),
});
